import React, { useState } from 'react';
import PageLayout from '../components/PageLayout';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const contactInfo = {
    email: 'kunalk30.ai@gmail.com',
    phone: '+91XXXXXXXXXX',
    responseTime: '24-48 hours'
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setFormData({ name: '', email: '', subject: '', message: '' });
      setSubmitted(false);
    }, 3000);
  };

  const inputClass = "w-full px-3 py-[12px] rounded border border-[#bdc3c7] text-base font-[Arial,sans-serif] transition-colors duration-300 box-border focus:outline-none focus:border-[#3498db]";

  return (
    <PageLayout>
      <div className="px-5 py-10 max-w-[1200px] mx-auto font-[Arial,sans-serif] text-[#2c3e50] w-full box-border">

        {/* Header */}
        <div className="text-center mb-[50px]">
          <h1 className="text-[clamp(1.8rem,5vw,2.5rem)] mb-[10px] text-[#2c3e50] break-words">
            Contact Us
          </h1>
          <p className="text-[1.1rem] text-[#7f8c8d] break-words">
            We'd love to hear from you. Get in touch with us today!
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-[repeat(auto-fit,minmax(350px,1fr))] gap-10 mb-10">

          {/* Contact Info */}
          <div className="flex flex-col gap-[25px]">
            <h2 className="text-2xl text-[#2c3e50] border-b-2 border-[#3498db] pb-[10px] mb-[15px]">
              Get In Touch
            </h2>

            {/* Email Card */}
            <div className="flex gap-[15px] p-5 bg-[#f8f9fa] rounded-lg border-l-4 border-[#3498db] overflow-hidden break-words">
              <div className="text-[2rem] min-w-[50px] text-center">📧</div>
              <div>
                <h3 className="text-[1.1rem] text-[#2c3e50] m-0 mb-[5px]">Email</h3>
                <a href={`mailto:${contactInfo.email}`}
                  className="text-[#3498db] no-underline font-bold text-base cursor-pointer break-words hover:text-[#2980b9]">
                  {contactInfo.email}
                </a>
                <p className="text-[0.85rem] text-[#95a5a6] m-0 mt-1">Primary contact method</p>
              </div>
            </div>

            {/* Phone Card */}
            <div className="flex gap-[15px] p-5 bg-[#f8f9fa] rounded-lg border-l-4 border-[#3498db] overflow-hidden break-words">
              <div className="text-[2rem] min-w-[50px] text-center">📱</div>
              <div>
                <h3 className="text-[1.1rem] text-[#2c3e50] m-0 mb-[5px]">Phone</h3>
                <a href={`tel:+91${contactInfo.phone}`}
                  className="text-[#3498db] no-underline font-bold text-base cursor-pointer break-words hover:text-[#2980b9]">
                  +91 {contactInfo.phone.slice(0, 4)} {contactInfo.phone.slice(4, 8)} {contactInfo.phone.slice(8)}
                </a>
                <p className="text-[0.85rem] text-[#95a5a6] m-0 mt-1">Call us during business hours</p>
              </div>
            </div>

            {/* Response Time Card */}
            <div className="flex gap-[15px] p-5 bg-[#f8f9fa] rounded-lg border-l-4 border-[#3498db] overflow-hidden break-words">
              <div className="text-[2rem] min-w-[50px] text-center">⏱️</div>
              <div>
                <h3 className="text-[1.1rem] text-[#2c3e50] m-0 mb-[5px]">Response Time</h3>
                <p className="text-base text-[#555] mb-[5px]">{contactInfo.responseTime}</p>
                <p className="text-[0.85rem] text-[#95a5a6] m-0">We'll get back to you ASAP</p>
              </div>
            </div>
          </div>

          {/* Form Section */}
          <div className="flex flex-col gap-5">
            <h2 className="text-2xl text-[#2c3e50] border-b-2 border-[#3498db] pb-[10px] mb-[15px]">
              Send us a Message
            </h2>

            {submitted && (
              <div className="px-[15px] py-[15px] bg-[#d4edda] text-[#155724] rounded text-center text-base border border-[#c3e6cb]">
                ✅ Thank you for your message! We'll get back to you soon.
              </div>
            )}

            <form onSubmit={handleSubmit} className="flex flex-col gap-5">

              <div className="flex flex-col gap-[5px]">
                <label htmlFor="name" className="text-[0.95rem] font-bold text-[#2c3e50]">
                  Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your Name"
                  className={inputClass}
                />
              </div>

              <div className="flex flex-col gap-[5px]">
                <label htmlFor="email" className="text-[0.95rem] font-bold text-[#2c3e50]">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="your@email.com"
                  className={inputClass}
                />
              </div>

              <div className="flex flex-col gap-[5px]">
                <label htmlFor="subject" className="text-[0.95rem] font-bold text-[#2c3e50]">
                  Subject *
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="How can we help?"
                  className={inputClass}
                />
              </div>

              <div className="flex flex-col gap-[5px]">
                <label htmlFor="message" className="text-[0.95rem] font-bold text-[#2c3e50]">
                  Message *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Your message here..."
                  rows="6"
                  className={`${inputClass} resize-y min-h-[150px]`}
                />
              </div>

              <button
                type="submit"
                className="px-[30px] py-[12px] bg-[#3498db] hover:bg-[#2980b9] text-white border-none rounded text-base font-bold cursor-pointer transition-colors duration-300 mt-[10px]"
              >
                Send Message
              </button>

            </form>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center px-5 py-[30px] bg-[#ecf0f1] rounded-lg text-[#2c3e50]">
          <p>Questions? Feel free to reach out using any of the methods above.</p>
        </div>

      </div>
    </PageLayout>
  );
};

export default ContactUs;